import { useState } from "react";

import { IconButton, Tooltip } from "@mui/material";
import { HelpOutline } from "@mui/icons-material";

import TicketsDialog from "components/support/TicketsDialog";

const LABEL = "Report an issue or suggest an improvement";

interface HelpButtonProps {
  /** The header's text colour, which differs per environment. */
  headerTextColor: string;
}

const HelpButton = ({ headerTextColor }: HelpButtonProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title={LABEL}>
        <IconButton
          color="inherit"
          aria-label={LABEL}
          onClick={() => setOpen(true)}
        >
          <HelpOutline sx={{ color: headerTextColor, display: "block" }} />
        </IconButton>
      </Tooltip>
      <TicketsDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default HelpButton;
